'use strict';

import {Flow} from "../lib/flowjs";
import moment from 'moment';
import ngTimePicker from 'angular-material-time-picker';

moment().format('YYYY-MM-DD');

const EwSiteApp = angular.module('EwSiteApp', ['ngMaterial', 'ngMessages', 'ngSanitize', 'md.data.table', 'flow', ngTimePicker]);

EwSiteApp.config(["$mdThemingProvider", function($mdThemingProvider) {
//	$mdThemingProvider.theme('default').primaryPalette('teal').accentPalette('deep-orange');//.warnPalette('red').backgroundPalette('grey');
//	$mdThemingProvider.theme('default').primaryPalette('teal').accentPalette('orange');//.warnPalette('red').backgroundPalette('grey');
	$mdThemingProvider.theme('default').primaryPalette('teal', {
		'default': '700'
	}).accentPalette('orange', {
		'default': '900'
	});//.warnPalette('red').backgroundPalette('grey');
	$mdThemingProvider.theme("success-toast");
	$mdThemingProvider.theme("error-toast");
}]);

EwSiteApp.config(["$httpProvider", function($httpProvider) {
	if(typeof(jsData) !== 'undefined' && typeof(jsData.cfgXsrf) !== 'undefined' && typeof(jsData.cfgXsrf.cookieName) !== 'undefined'){
		$httpProvider.defaults.xsrfCookieName = jsData.cfgXsrf.cookieName;
		$httpProvider.defaults.xsrfHeaderName = 'X-' + jsData.cfgXsrf.cookieName;
	}
}]);

EwSiteApp.config(["$mdDateLocaleProvider", function($mdDateLocaleProvider) {
	$mdDateLocaleProvider.firstDayOfWeek = 1;
	if(typeof(jsData) !== 'undefined' && typeof(jsData.cfgTime) !== 'undefined'){
		$mdDateLocaleProvider.formatDate = function(date) {
			var m = moment(date);
			return m.isValid() ? m.format('YYYY-MM-DD') : '';
		};
	}
}]);

EwSiteApp.filter('u2date', ["$filter", function($filter){
	return function (udate){
		var format = 'yyyy-MM-dd';
		if(arguments[1]){
			format = arguments[1];
		}
		return $filter('date')(udate*1000, format);
	};
}]);

EwSiteApp.config(['flowFactoryProvider', function (flowFactoryProvider) {
	function getJsCookieValue(a){
		let b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
		return b ? b.pop() : '';
	}
	flowFactoryProvider.defaults = {
		target: '',
		permanentErrors: [202, 404, 500, 501],
//		permanentErrors: [414, 500, 501],
		maxChunkRetries: 1,
		chunkRetryInterval: 5000,
		simultaneousUploads: 1,
		singleFile: true,
		chunkSize: 2 * 1024 * 1024,
		forceChunkSize: true,
		testChunks: false
	};
	// Apejimas https://lightrun.com/answers/flowjs-ng-flow-unable-to-initialize-module-using-browserify
	//	https://github.com/flowjs/ng-flow/issues/92
	flowFactoryProvider.factory = function (opts) {
		let Flow = require('@flowjs/flow.js/dist/flow.js');
		return new Flow(opts);
	};
	// Add XSRF header to upload requests
	if(typeof(jsData) !== 'undefined' && typeof(jsData.cfgXsrf) !== 'undefined' && typeof(jsData.cfgXsrf.cookieName) !== 'undefined'){
		let xsrf_token = getJsCookieValue(jsData.cfgXsrf.cookieName);
		if(xsrf_token !== ''){
			flowFactoryProvider.defaults.headers = {};
			flowFactoryProvider.defaults.headers['X-' + jsData.cfgXsrf.cookieName] = xsrf_token;
		}
	}
	flowFactoryProvider.on('fileSuccess', function (file, response) {
		file.response = angular.fromJson(response);
	});
}]);

EwSiteApp.filter('nl2br', function(){
	return function (text){
		return text.replace(/\n/g, "<br\>");
	};
});

EwSiteApp.directive('ewFocused', function(){
	return function(scope, elem, attr){
		elem[0].focus();
	};
});

EwSiteApp.filter('tr', ["jsDataService", function(jsDataService){
	const trData = jsDataService.get('translations', {});
	return function (text){
		if(typeof(trData[text]) !== 'undefined'){
			return trData[text];
		}
		return '*' + text + '*';
	};
}]);

EwSiteApp.directive('ewLongText', function(){
	return {
		restrict: 'E',
		scope: {
			text: '=',
			length: '=?'
		},
		link: function(scope){
			scope.long = false;
			scope.position = 'top';
			if(isNaN(scope.length)){
				scope.length = 100;
			}
			else{
				scope.length = parseInt(scope.length);
			}
			scope.long = (scope.text.length > scope.length);

		},
		template: '<md-tooltip ng-if="long" md-direction="{{position}}" class="ew-long-text" ng-bind-html="text"></md-tooltip><div ng-if="long" class="ew-long-text-holder" ><span ng-bind-html="text|limitTo:length|sanitize"></span>...</div><div ng-if="!long" ng-bind-html="text|sanitize"></div>'
	};
});

EwSiteApp.filter('sanitize', function(){
	return function (str){
		var re = new RegExp("(https{0,1}:\\/\\/[^\\s]+|www\.[^\\s]+)(\\s|$)","igm");

		return str.replaceAll(re,function(rep,link,end){
			var linkSize = 36;
			var short_link = link;
			if(!link.match(/^((http|https):\/\/|\/[^\/])/i)){
				link = 'http://'+link;
			}
			if(short_link.length>linkSize){
				short_link = short_link.substr(0, linkSize)+"...";
			}
			return '<a href="'+link+'" target="_blank" title="'+link+'" rel="noreferrer noopener">'+short_link+'</a>'+end;
		});
	};
});

EwSiteApp.filter('stripTags', function(){
	return function (str){
		function Filter(text){
			return text ? String(text).replace(/<[^>]+>/gm, ' ') : '';
		}
		
		return Filter(str);
	};
});
export {EwSiteApp};
